import setValueRadio from './setValueRadio'
import updateDOM from './updateDOM'
import setErrorMessage from './setErrorMessage'
import getById from 'utils/DOM/getById'

const ERROR_MESSAGE = 'Please select a valid option.'

function buildControllerGender({ inputs }) {
  const name = inputs[0].name

  const state = {
    inputs,
    wrap: getById(`wrap-${name}`),
    errorWrap: getById(`error-${name}`),
    valid: false,
    error: false
  }

  function isOK() {
    state.error = false
    state.valid = true
    updateDOM(state)
  }

  $(state.wrap).on('click change', 'input', isOK)

  return {
    setValue: value => setValueRadio(state, value),
    getStatus: () => {
      const values = []
      for (let index = 0; index < state.inputs.length; index++) {
        if (state.inputs[index].checked) {
          values.push(state.inputs[index].value)
        }
      }

      return {
        valid: state.valid,
        value: values.join(',')
      }
    },
    validate: () => {
      if (!state.valid) {
        setErrorMessage(state, ERROR_MESSAGE)
        updateDOM(state)
      }
    },
    destroy: () => {}
  }
}

export default buildControllerGender
